var cache = {}

export default function(email,lang,unsubscribe,done){

  if(unsubscribe === undefined){
    unsubscribe = false
  }

  $.ajax({
    url: `/frontend?type=news&email=${email}&lang=${lang}&unsubscribe=${unsubscribe}`,
    type: "GET",
  })
  .done(function(data, textStatus, jqXHR) {
    done(null, data)
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    console.error('subscription api error')
    done('subscription api error')
  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/newsSubscription/newsSubscription.js